import marketService from 'services/market'

export type AlertDirection = 'HIGHER' | 'LOWER'

const $radioLower = document.getElementById('lower') as HTMLInputElement
const $radioHigher = document.getElementById('higher') as HTMLInputElement
const $currencySelect = document.getElementById('alert-select') as HTMLInputElement
const $range = document.querySelector('[data-rate-notification-slider]') as HTMLInputElement

const SLIDER_LIMIT_VALUE = 0.05
const SLIDER_LESS_LIMIT_VALUE = 0.005
const STEP_VALUE = 0.001
const STEP_LESS_VALUE = 0.0001
const SLIDER_INIT_FACTOR = 0.0002
const SLIDER_RADIO_HIGHER_CHANGE_FACTOR = 1.005
const SLIDER_RADIO_LOWER_CHANGE_FACTOR = 0.995
const SLIDER_RADIO_HIGHER_SMALL_CHANGE_FACTOR = 1.02
const SLIDER_RADIO_LOWER_SMALL_CHANGE_FACTOR = 0.98
const SLIDER_RADIO_HIGHER_BIG_CHANGE_FACTOR = 1.0009
const SLIDER_RADIO_LOWER_BIG_CHANGE_FACTOR = 0.9991

const alertHelper = {
  getCheckedRadioValue: (): AlertDirection =>
    $radioHigher.checked ? ($radioHigher.value as 'HIGHER') : ($radioLower.value as 'LOWER'),
  getAverageRate: (): number => {
    const pair = marketService.getMarketBrief().find((el) => el.pair === `${$currencySelect.value}_PLN`)
    return pair?.directExchangeOffers.forexNow || 0
  },
  getInitRangeValue: (): number => alertHelper.getAverageRate() + SLIDER_INIT_FACTOR,
  getMaxRangeValue: (): number => alertHelper.getAverageRate() + alertHelper.getSliderLimitValue(),
  getMinRangeValue: (): number => alertHelper.getAverageRate() - alertHelper.getSliderLimitValue(),
  getSliderLimitValue: (): number =>
    alertHelper.getAverageRate() - SLIDER_LIMIT_VALUE < 0 ? SLIDER_LESS_LIMIT_VALUE : SLIDER_LIMIT_VALUE,
  getStepValue: (): number => (alertHelper.getAverageRate() - SLIDER_LIMIT_VALUE < 0 ? STEP_LESS_VALUE : STEP_VALUE),
  isRateWarning: (value: string): boolean =>
    parseFloat(value) > alertHelper.getMaxRangeValue() || parseFloat(value) < alertHelper.getMinRangeValue(),
  shouldSetHigher: (value: string) =>
    parseFloat(value) >= alertHelper.getAverageRate() && alertHelper.getCheckedRadioValue() !== 'HIGHER',
  shouldSetLower: (value: string) =>
    parseFloat(value) < alertHelper.getAverageRate() && alertHelper.getCheckedRadioValue() !== 'LOWER',
  getInputValueOnRadioChange: (): string => {
    const avgRate = alertHelper.getAverageRate()
    const isSmallRate = avgRate < 0.01
    const isBigRate = avgRate > 10
    let result: number

    switch (alertHelper.getCheckedRadioValue()) {
      case 'HIGHER':
        if (isBigRate) {
          result = avgRate * SLIDER_RADIO_HIGHER_BIG_CHANGE_FACTOR
        } else if (isSmallRate) {
          result = avgRate * SLIDER_RADIO_HIGHER_SMALL_CHANGE_FACTOR
        } else {
          result = avgRate * SLIDER_RADIO_HIGHER_CHANGE_FACTOR
        }
        return Math.min(result, alertHelper.getMaxRangeValue()).toFixed(4)

      case 'LOWER':
        if (isBigRate) {
          result = avgRate * SLIDER_RADIO_LOWER_BIG_CHANGE_FACTOR
        } else if (isSmallRate) {
          result = avgRate * SLIDER_RADIO_LOWER_SMALL_CHANGE_FACTOR
        } else {
          result = avgRate * SLIDER_RADIO_LOWER_CHANGE_FACTOR
        }
        return Math.max(result, alertHelper.getMinRangeValue()).toFixed(4)

      default:
        return avgRate.toFixed(4)
    }
  },
  calculateTrackerPosition: (sliderCurrentValue: string): number => {
    const sliderValue = parseFloat(sliderCurrentValue.replace(',', '.'))
    const min = parseFloat($range.min.replace(',', '.'))
    const max = parseFloat($range.max.replace(',', '.'))
    const value = sliderValue < min ? min : sliderValue > max ? max : sliderValue
    let percentage = (value - min) / (min - max)
    percentage += 0.5
    percentage *= 92 // 100 percents reduced by input padding & thumb width
    percentage *= -1
    return Math.round(percentage * 10) / 10
  },
}

export default alertHelper
